import {useState} from 'react';

/**
 * Хук для принудительного ререндера компонента
 * 
 * @returns {() => void} Функция, вызов которой вызывает ререндер компонента
 * 
 */
export const useForceUpdate = () => {
    const [, setTick] = useState(0);
    return () => setTick(tick => tick + 1);
}